// 生成随机日期
import {ref} from "vue";

export function getRandomDate(numDays, type) {
    const today = new Date();
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - 15); // 最早的日期是今天的前15天
    const dates = [];
    const usedDates = new Set();
    while (dates.length < numDays) {
        const randomDate = new Date(startDate.getTime() + Math.random() * (today.getTime() - startDate.getTime()));
        const dateKey = randomDate.toDateString(); // 将日期转换为字符串格式，以便存储在Set中
        if (!usedDates.has(dateKey)) {
            usedDates.add(dateKey);
            // console.log(usedDates)
            let year = randomDate.getFullYear()
            // console.log(year)
            let newMonth = ('0' + (randomDate.getMonth() + 1)).slice(-2)
            let newDay = ('0' + randomDate.getDate()).slice(-2)
            if(type==1){
                var DateItem = newMonth + '.' + newDay
            }else if(type==2){
                var DateItem = year+ '.' +newMonth + '.' + newDay
            }else if(type==3){
                var DateItem = newMonth + '-' + newDay
            }else{
                var DateItem = year+ '-' +newMonth + '-' + newDay
            }
            // console.log(DateItem)
            dates.push(DateItem);
        }
    }
    // 对日期数组进行排序
    dates.sort((a, b) => new Date(a) - new Date(b));
    return dates;

}
// 获取随机日期
const clearLocalStorage = () => {
    localStorage.removeItem('recentDate');
    console.log("清除")
};
let intervalId = null;
export function setRandomDate(numDays,type){
    let dateArr=[]
    let recentDate = localStorage.getItem("recentDate");
    if(recentDate){
        dateArr = recentDate.split(',')
    }else{
        const daysAgo = ref(numDays,type);
        const recentDate = getRandomDate(daysAgo.value,type);
        localStorage.setItem('recentDate', recentDate);
        intervalId = setInterval(clearLocalStorage, 3 * 24 * 60 * 60 * 1000);
        dateArr = recentDate
    }
    return dateArr

}
export function timeStr(timeStr,type) {
    // 将时间字符串转换为Date对象
    var date = new Date(timeStr)
    // 提取年、月、日
    var year = date.getFullYear()
    var month = ('0' + (date.getMonth() + 1)).slice(-2)
    var day = ('0' + date.getDate()).slice(-2)
    const hours = date.getHours()
    // const minutes = date.getMinutes()
    // 拼接年月日字符串
    if(type == 1){
        var ymdStr =  month + '-' + day
    }
    if(type == 2){
        // time: '2023-11-12 18:00',
        var ymdStr =  year +  '-' + month + '-' + day +' '+ hours + ':00'
    }

    // 返回年月日字符串
    return ymdStr
}